import {getAllCardList} from "@model/card";

let mBoard:any;
export function initBoard(db){
    mBoard = db.table('projectBoard');
}

/**
 * 更新
 * @param board
 */
export function updateBoard(board){
    if (!board.createTime){
        board.createTime = Date.now();
    }
    board.updateTime = Date.now();
    return mBoard.put(board);
}

export function getBoardById(szBoardId){
    return mBoard.get(szBoardId);
}

export function batchUpdateBoard(arrayBoards){
    return mBoard.bulkPut(arrayBoards);
}

export function deleteBoardById(szBoardId){
    return mBoard.delete(szBoardId);
}

export function getBoardList(szSearchKey){
    return new Promise(async (resolve) => {
        let arrays = await mBoard.toArray();
        if (szSearchKey){
            arrays = arrays.filter(p=>p.title?.toLowerCase().includes(szSearchKey.toLowerCase()));
        }
        resolve(arrays);
    })
}

/**
 * 统计board中是否包含某一tags
 * @param szTagName
 */
export function statBoardCountByTags(szTagName){
    return mBoard.where('tags').equals(szTagName).count();
}

export function getBoardByTagName(szTagName,szFilterTag,szSearchKey){
    return new Promise(async (resolve, reject) => {
        const arrayCards:any = await getBoardList(szSearchKey);
        let arrayLibrarys = (arrayCards.filter(p=>p.tags?.includes(szTagName)));
        if (szFilterTag){
            arrayLibrarys = arrayLibrarys.filter(p=>p.tags.includes(szFilterTag))
        }
        resolve(arrayLibrarys);
    })
}

/**
 * 获取收藏的
 */
export async function getBoardFavorList(){
    return mBoard.where('isFavirated').equals(1).toArray();
}